import styled from 'styled-components';
import { FlexBox, ListView, StackPanel, typographyPresets } from '@agilepoint/wat-react-ux';
import { CheckboxField } from '@agilepoint/wat-react-ux-form-fields';
import { SectionLabel } from './common-styles';
import { RadioGroupField } from 'common';

export const AppListOptionsWrapper = styled(SectionLabel)`
    padding: 12px;
    box-sizing: border-box;
    height: 75px;
`;

export const StyledRadioGroupField = styled(RadioGroupField)`
    color: ${({ theme: { semantics: { palette } } }) => palette.neutralPrimary};
    .ap-radioGroup-wrapper {
        width: 100%;
    }
    .ap-radioGroup-options-wrapper {
        flex-direction: column;
        gap: 15px;
        flex-wrap: unset;
        width: 100%;
    }
    .ap-radioButton-wrapper {
        margin: 0 !important;
    }

    .ap-radiobutton {
        display: flex;
        .ap-radioButton-label {
            ${typographyPresets.textStyles.small}
            width: calc(100% - 20px);
            display: block;
        }
    }
`;

export const StyledListView = styled(ListView)`
    border: none !important;
    height: calc(100% - 40px);
    .ap-listView-itemContentWrapper {
        border-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
        margin-right: ${({ theme: { semantics: { gap} } }) => gap.xxxxl};
        width: calc(100% - 30px);
        border-right: 0px;
    }
`;

export const AppSelecionWrapper = styled(FlexBox) <{ $padding?: string }>`
    border: 1px solid ${({ theme: { mobileAppAccelerator: { semanticColors: { wizard } } } }) => wizard.stepSeparatorColor};
    padding: ${({ $padding }) => $padding ?? '0px 0px 0px 30px'};
    box-sizing: border-box;
    border-radius: 6px;
`;

export const AppSelectionHeaderWrapper = styled(StackPanel)`
    color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant2};
`;

export const StyledCheckboxField = styled(CheckboxField)`
    .ap-checkbox {
        background-color: ${({ disabled, theme }) => (disabled && theme.mobileAppAccelerator.semanticColors.grayVariant4)};
        border-color: ${({ disabled, theme }) => (disabled && theme.mobileAppAccelerator.semanticColors.grayVariant4)};
        opacity: unset;
    }
    .ap-icon {
        fill: #fff;
    }
`;
